import { useCallback } from 'react';
import { compact } from 'lodash';

import { CHANNEL, shouldChannelConnectManually } from 'src/data/channel';
import { EMAIL_CSV_RESOURCES, flatConnectedAccounts } from 'src/data/performance';
import { SOCIAL_AUTH_STATE } from 'src/data/user';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { useChannelAccounts } from 'src/services';
import { PerformanceStore } from 'src/store';

const usePerformanceState = createStateSelectorHook(PerformanceStore, [
  'authStateMap',
  'wtmProjects',
]);

export const useCheckChannelConnected = () => {
  const { authStateMap, wtmProjects } = usePerformanceState();
  const { connectedAccounts } = useChannelAccounts();

  const getChannelAccounts = useCallback(
    (channel) => {
      if (channel === CHANNEL.projectWtm) {
        return wtmProjects;
      }

      if (!connectedAccounts) {
        return [];
      }

      if (channel === CHANNEL.emailChannel) {
        const accountsPerChannel = compact(
          EMAIL_CSV_RESOURCES.map((channel) => connectedAccounts[channel])
        );
        return flatConnectedAccounts(accountsPerChannel, true);
      }

      return connectedAccounts[channel];
    },
    [connectedAccounts, wtmProjects]
  );
  return useCallback(
    (channel) => {
      const isAuthorized = authStateMap[channel] === SOCIAL_AUTH_STATE.authorized;
      if (shouldChannelConnectManually(channel)) {
        return isAuthorized || getChannelAccounts(channel)?.length > 0;
      }
      return isAuthorized;
    },
    [authStateMap, getChannelAccounts]
  );
};
